import {
  put, all, call, select, takeEvery, takeLatest,
} from 'redux-saga/effects';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { morphShipmentToUI } from 'domain/order/utils';
import { exception } from 'circe/logger';
import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import {
  fetch,
  fetching,
  fetched,
  fetchQuoteShipments,
  fetchingQuoteShipments,
  fetchedQuoteShipments,
} from './actions';
import * as api from './api';
import { morphUsingState } from '../view/utils';

const doFetch = function* ({ payload }) {
  try {
    const { sid, iid } = payload;

    const state = yield select();

    yield put(fetching());

    const results = yield call(api.fetch, sid, iid);

    if (!results) {
      throw new Error(`Shipment Book View failed to load ${sid}`);
    }

    const morphed = morphUsingState(morphShipmentToUI(results), state);

    yield put(fetched(morphed));
  } catch (e) {
    exception(e);
  }
};

const doFetchQuoteShipments = function* ({ payload }) {
  try {
    const { qId, shipmentsIds } = payload;
    const state = yield select();
    // const { quotes, price } = getQuote(state, qId);

    yield put(fetchingQuoteShipments());

    const headers = yield call(getCurrentAuthHeader, state);

    const results = yield call(api.fetchQuoteShipments, qId, headers);

    if (!results) {
      throw new Error(`Book View failed to load ${qId}`);
    }

    const morphedShipments = results.map((result) => morphShipmentToUI(result)); // morphUsingState(morphShipmentToUI(result), state));

    yield put(fetchedQuoteShipments(morphedShipments));
  } catch (e) {
    exception(e);
    yield put(
      showNotification(
        I18n.str('unableToFetchShipments', 'Sorry, Unable to fetch shipments.'),
        'error',
      ),
    );
  }
};

export default function* () {
  yield all([
    takeLatest(fetch().type, doFetch),
    takeLatest(fetchQuoteShipments().type, doFetchQuoteShipments),
  ]);
}
